import { render } from "./CategorysEdit.vue?vue&type=template&id=7dbce9cb"
import script from "./CategorysEdit.vue?vue&type=script&lang=js"
export * from "./CategorysEdit.vue?vue&type=script&lang=js"

import "./CategorysEdit.vue?vue&type=style&index=0&id=7dbce9cb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__